import React from 'react';
export function SectionDivider() {
  return <div className="py-4" data-id="element-480">
      <div className="max-w-7xl mx-auto px-4" data-id="element-481">
        <div className="h-[5px] bg-gradient-to-r from-transparent via-[#E87B5C] to-transparent rounded-full" data-id="element-482"></div>
        <div className="h-[5px]" data-id="element-483"></div>
        <div className="h-[5px] bg-gradient-to-r from-transparent via-[#E87B5C] to-transparent rounded-full" data-id="element-484"></div>
      </div>
    </div>;
}